import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Eye, Puzzle, Check } from 'lucide-react';
import BusinessReservationsPage from './BusinessReservationsPage';
import BusinessMenuPage from './BusinessMenuPage';
import BusinessCardPage from './BusinessCardPage';
import { DEMOS, PLUGINS, pluginsFor, demoKind } from '../data/businessCatalog';

export default function BusinessDemoPage() {
  const { template: demoId } = useParams();
  const navigate = useNavigate();
  const data = DEMOS[demoId] || DEMOS.reservations;
  const { template, kind } = demoKind(DEMOS[demoId] ? demoId : 'reservations');
  const plugins = pluginsFor(template, kind);

  const Inner = template === 'menu' ? BusinessMenuPage : template === 'business_card' ? BusinessCardPage : BusinessReservationsPage;

  return (
    <div data-testid="business-demo-page">
      <div className="fixed top-0 inset-x-0 z-50 bg-amber-500 text-[#0A0A0A] text-sm font-semibold px-4 py-2 flex items-center justify-between" data-testid="demo-banner">
        <span className="flex items-center gap-2"><Eye className="w-4 h-4" /> Šis ir DEMO piemērs — tā varētu izskatīties tava biznesa lapa</span>
        <button onClick={() => navigate('/business-templates')} className="inline-flex items-center gap-1 bg-[#0A0A0A] text-white rounded-full px-3 py-1 text-xs hover:bg-black" data-testid="demo-back-btn">
          <ArrowLeft className="w-3.5 h-3.5" /> Atpakaļ uz veidnēm
        </button>
      </div>

      <div className="pt-10">
        <Inner data={data} userId="demo" />
      </div>

      {/* Available plugins for this business type */}
      <div className="bg-[#0A0A0A] border-t border-white/10 py-14" data-testid="demo-plugins-section">
        <div className="max-w-5xl mx-auto px-5">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-amber-500 mb-2 flex items-center gap-2">
            <Puzzle className="w-4 h-4" /> Papildmoduļi
          </p>
          <h2 className="text-3xl font-light tracking-tighter text-white mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Pieejamie papildmoduļi šim biznesa tipam
          </h2>
          <p className="text-white/50 text-sm mb-8 max-w-2xl">
            Katru moduli vari ieslēgt vai izslēgt savā vadības panelī. Ieslēdz tikai tos, kas tev vajadzīgi.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {plugins.map((pid) => {
              const p = PLUGINS[pid];
              if (!p) return null;
              const Icon = p.icon;
              return (
                <div key={pid} className="rounded-2xl border border-white/10 bg-white/[0.03] p-5 flex gap-3" data-testid={`demo-plugin-${pid}`}>
                  <div className="w-10 h-10 rounded-xl bg-amber-500/15 flex items-center justify-center shrink-0">
                    <Icon className="w-5 h-5 text-amber-400" />
                  </div>
                  <div className="min-w-0">
                    <p className="text-white font-semibold text-sm flex items-center gap-1.5">{p.label}</p>
                    <p className="text-white/45 text-xs mt-1 leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="mt-8 flex items-center gap-2 text-white/40 text-xs">
            <Check className="w-4 h-4 text-amber-400" /> Visi moduļi ir iekļauti — bez papildu maksas.
          </div>
        </div>
      </div>
    </div>
  );
}
